export default "__VITE_ASSET__B1UK_tPX__"